import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SubmissionRequest from './submission-request';
import SubmissionRequestDetail from './submission-request-detail';
import SubmissionRequestUpdate from './submission-request-update';
import SubmissionRequestDeleteDialog from './submission-request-delete-dialog';

const SubmissionRequestRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SubmissionRequest />} />
    <Route path="new" element={<SubmissionRequestUpdate />} />
    <Route path=":id">
      <Route index element={<SubmissionRequestDetail />} />
      <Route path="edit" element={<SubmissionRequestUpdate />} />
      <Route path="delete" element={<SubmissionRequestDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SubmissionRequestRoutes;
